import type { Reducer } from "@reduxjs/toolkit";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as IndustryActions from "./actions";
import type { IIndustryState } from "./types";

export type IndustryAction = ActionType<typeof IndustryActions>;

const initialState: IIndustryState = {
  isFetching: false,
  hasError: false,
  config: null!
};

const industryReducer: Reducer<IIndustryState, IndustryAction> = (state = initialState, action: IndustryAction) => {
  switch (action.type) {
    case getType(IndustryActions.fetchIndustryConfigStart):
      return { ...state, isFetching: true };

    case getType(IndustryActions.fetchIndustryConfigSuccess):
      return { ...state, isFetching: false, config: action.payload };

    case getType(IndustryActions.fetchIndustryConfigFail):
      return { ...state, isFetching: false, hasError: true };

    default:
      return state;
  }
};

export default industryReducer;
